import { ElMessage } from 'element-plus'
import { showFailToast, showSuccessToast, showToast } from 'vant'

import { deviceInfo } from '@/utils/system'

export function useToast() {
  const isMobile = computed(() => deviceInfo.value.isMobile)

  function info(message: string) {
    if (isMobile.value) {
      showToast({
        message: message,
        zIndex: 3000,
        className: '.mb-toast .mb-toast--text'
      })
    } else {
      ElMessage.info(message)
    }
  }

  function success(message: string) {
    if (isMobile.value) {
      showSuccessToast({
        message: message,
        zIndex: 3000,
        className: '.mb-toast'
      })
    } else {
      ElMessage.success(message)
    }
  }

  function warning(message: string) {
    if (isMobile.value) {
      showFailToast({
        message: message,
        zIndex: 3000,
        className: '.mb-toast'
      })
    } else {
      ElMessage.warning(message)
    }
  }

  function error(message: string) {
    if (isMobile.value) {
      showToast({
        message: message,
        icon: 'clear',
        zIndex: 3000,
        className: '.mb-toast'
      })
    } else {
      ElMessage.error(message)
    }
  }

  return {
    info,
    success,
    warning,
    error
  }
}
